import { getPortalTheme, fieldSxFromTheme, PORTAL_THEMES } from '../studentPortal/portalTheme';

export { getPortalTheme, fieldSxFromTheme, PORTAL_THEMES };

export function getGabbaiTheme() {
  return getPortalTheme(true);
}
